import axios from "axios";
import { getToken } from "./component/Utils/Common";


const customAxios = axios.create({
    baseURL: `http://35.154.221.117:8081/erp_maa_ff_scope_sTs_v1/ng_pillai/sit`,
    // baseURL: `http://35.154.221.117:8081/ngp_erp_stsV2/ng_pillai/sit`, //another ngp branch
    // baseURL: `http://192.168.1.23:8080/ng_pillai/sit`,
    // baseURL: `http://localhost:8080/ngp_erp_stsV1-0.0.1/ng_pillai/sit`,
    timeout: 110000 
    // headers: { 'api-key': 'eyJz-CI6Ikp-4pWY-lhdCI6' }
});

// Step-2: Create request, response & error handlers
const requestHandler = request => {
    // Token will be dynamic so we can use any app-specific way to always   
    // fetch the new token before making the call
    request.headers.Authorization = getToken();
    // console.log("axios call token "+JSON.stringify(getToken()));
    return request;
};

const responseHandler = response => {
    // console.log("response.status "+JSON.stringify(response.status)); 
    if (response.status === 401) {
        // window.location.replace('/');
    }

    return response;
};

const errorHandler = error => {
    console.log("error call " + JSON.stringify(error.message));
    if (error.message === 'Request failed with status code 401') {
        // window.location.replace('/ngp_erp');
    } else if (error.message === 'Network Error') {
        // window.location.replace('/ngp_erp');
    } else {
        return Promise.reject(error);
    }
};

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
customAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
);


// Step-4: Export the newly created Axios instance to be used in different locations.
export default customAxios;